// 表单验证规则
import { t } from '@/i18n'

export const taskValidators = {
  name: [
    { required: true, message: t('请输入任务名称') },
    { max: 50, message: t('任务名称不能超过50个字符') },
  ],
  validationMode: [{ required: true, message: t('请选择验证模式') }],
  securityDevices: [{ required: true, message: t('请选择安全设备') }],
  agentToContainer: {
    agentId: [{ required: true, message: t('请选择攻击主体') }],
    containerId: [{ required: true, message: t('请选择目标主体') }],
  },
  containerAgentToListener: {
    agentId: [{ required: true, message: t('请选择攻击主体') }],
    listenerId: [{ required: true, message: t('请选择目标主体') }],
  },
  executionRate: [
    { required: true, message: t('请输入执行频率') },
    { type: 'number', min: 1, max: 100, message: t('执行频率必须在1-100之间') },
  ],
  priority: [
    { required: true, message: t('请输入优先级') },
    { type: 'number', min: 1, max: 10, message: t('优先级必须在1-10之间') },
  ],
}
